import clsx from 'clsx';
import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';

import {
  CENTER,
  alignmentValues,
  backgroundColorValues,
  marginValues,
  paddingValues,
} from './constants';
import type { ImageBlockProps } from './interfaces';

const Image = ({ content, config }: ImageBlockProps) => (
  <LazyImgixImage
    alt={content?.alt}
    className={clsx(
      'image-block mb-0 mt-24 w-full',
      config?.css_classes,
      config?.alignment === CENTER ? 'mx-auto block' : alignmentValues[config?.alignment],
      !content?.caption && config?.width && `max-w-[${config?.width}px]`,
      backgroundColorValues[config?.background_color],
      marginValues[config?.margin],
      paddingValues[config?.padding]
    )}
    src={content.src}
    visibleByDefault={false}
  />
);

const ImageWithLink = ({ content, config }: ImageBlockProps) => (
  <a className="inline-block w-full *:w-full" href={content.link} target="_blank" rel="noreferrer">
    <Image content={content} config={config} />
  </a>
);

const ImageBlock = ({ config, content }: ImageBlockProps) => {
  if (!content.src) return null;

  const width = Number(config?.width);

  if (content.caption) {
    return (
      <figure
        className={clsx(
          'image-block-with-caption relative m-0 w-full *:w-full',
          width && !isNaN(width) && `max-w-[${width}px]`
        )}
      >
        {content.link ? (
          <ImageWithLink content={content} config={config} />
        ) : (
          <Image content={content} config={config} />
        )}
        <figcaption className="text-caption-md">{content.caption}</figcaption>
      </figure>
    );
  } else if (content.link) {
    return <ImageWithLink content={content} config={config} />;
  } else {
    return <Image content={content} config={config} />;
  }
};

export default ImageBlock;
